var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('inner-surevy-page-header',{attrs:{"links":_vm.links,"surveyData":_vm.surveyData,"type":'YES'}}),_c('persona-filter'),_c('div',{ref:"surveyChartsContainer",staticClass:"survey-charts-container mt-4 pb-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }